module.exports = __webpack_public_path__ + "img/logo1.bb22dc60.png";